module.exports = __webpack_public_path__ + "04996e19b47b0fc644135db891533d49.png";